const SET_REPEATED_FROM = 'mrDistribution/SET_REPEATED_FROM';

export default {
  SET_REPEATED_FROM,
};
